import { brazilCountry } from '../../../../lib/countries';
import { phoneUnmask } from '../../../../utils/formatters';
import { onlyNumbersAndLetters, unmaskCpfCnpj } from '../../../../utils/validators';
import { LoginContext } from '../../../login/AuthContext';
import { SignUpApiPayloadRequest } from '../../types/createAccount.types';
import { SignUpState } from '../../types/signUp.types';
import { CreateAccountFormValues } from '../validator/createAccount.schema';

interface FormatSignUpPayloadArgs {
  formData: CreateAccountFormValues;
  storeData: any;
  loginContext: LoginContext | undefined;
  state: SignUpState;
}

export const formatSignUpPayload = ({
  formData,
  storeData,
  loginContext,
  state,
}: FormatSignUpPayloadArgs): SignUpApiPayloadRequest => {
  const isBrazil = state.location?.code === brazilCountry.code;

  const formattedCpfCnpj = storeData?.cpfcnpj
    ? isBrazil
      ? unmaskCpfCnpj(storeData.cpfcnpj)
      : storeData.cpfcnpj
    : null;

  const formattedZipCode = storeData?.address?.zipCode
    ? onlyNumbersAndLetters(storeData.address.zipCode)
    : undefined;

  const loginContextFromEvents = loginContext?.slug?.split('/')[0] === 'events';

  const payload: SignUpApiPayloadRequest = {
    name: formData.name,
    surname: formData.surname,
    email: formData.email?.trim(),
    password: formData.password,
    phone: phoneUnmask(formData.phone),
    countryCode: storeData?.countryCode,
    store: {
      ...storeData,
      cpfcnpj: formattedCpfCnpj,
      email: storeData?.email?.trim(),
      phone: storeData?.phone
        ? storeData.phone.slice(storeData.countryCode?.length || 0)
        : undefined,
      address: {
        ...storeData?.address,
        zipCode: formattedZipCode,
      },
    },
    fromBrandId: !loginContextFromEvents ? loginContext?.id : undefined,
  };

  return payload;
};
